import { CheckId } from '../types/errorCatalog';

/** Translation keys for the "There is a problem" copy (`/error`, `/v2/error`). */
export type GeneralErrorMessage = { h1: string; p: string; p2: string };

const SESSION_IS_ONGOING_MESSAGE: GeneralErrorMessage = {
  h1: 'generalErrorWrapper.messages.19.h1',
  p: 'generalErrorWrapper.messages.19.p',
  p2: 'generalErrorWrapper.messages.19.p2',
};

const DEFAULT_MESSAGE: GeneralErrorMessage = {
  h1: 'generalErrorWrapper.messages.default.h1',
  p: 'generalErrorWrapper.messages.default.p',
  p2: 'generalErrorWrapper.messages.default.p2',
};

/**
 * Copy for the general error screen, keyed by the internal error code it was
 * navigated with. Shared by the legacy `GeneralErrorWrapper` and the responsive
 * `GeneralErrorPage`, so a session that opened in two tabs (code 19) reads the
 * same explanation on either track.
 */
export const getGeneralErrorMessage = (
  errorCode: string | number | undefined
): GeneralErrorMessage =>
  String(errorCode) === CheckId.SESSION_IS_ONGOING
    ? SESSION_IS_ONGOING_MESSAGE
    : DEFAULT_MESSAGE;
